import { Transaction, ITransaction } from './../models/transaction.model';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from "@angular/core";
import {environment} from '../environments/environment';
@Injectable({
  providedIn: 'root'
})

export class TransactionService{

  constructor(private http: HttpClient){}

  getTransaction() : Observable<Transaction>{
    return this.http.get<Transaction>(`${environment.url}/transaction`);
  }

  getAllTransactions(): Observable<any> {
    return this.http.get<any>(`${environment.url}/v1/transaction`);
  }

  transactionOrder(): Observable<any> {
    return this.http.get<any>(`${environment.url}/transaction/transactionOrder`);
  }

  transactionOrder_v1(page: number, size: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get(`${environment.url}/transaction/transactionsOrder?page=${page}&size=${size}`, { headers: headers });
  }

  transactionOrder_v1_1(startDate: any, endDate: any, page: number, size: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get(`${environment.url}/transaction/transactionsOrder?startDate=${startDate}&endDate=${endDate}&page=${page}&size=${size}`, { headers: headers });
  }

  transactionGiftCard(): Observable<any> {
    return this.http.get<any>(`${environment.url}/v1/transaction/giftcard`);
  }

  getTransactionBycurrentSearch(search: string, page: number, size: number){
    return this.http.get<any>(`${environment.url}/transaction` + ('/_search?search=name:' + search +'&page=' + page + "&size=" + size));
  }

  saveTransaction(Transaction:ITransaction)
  {
    return this.http.post<any>(`${environment.url}/transaction`,Transaction);
  }

  getIdTransaction(idA:number)
  {
    return this.http.get(`${environment.url}/transaction/`+idA);
  }

  getTransactionBycategorie(id : number)
  {
    return this.http.get(`${environment.url}/circle_graph_info/circleGraph/`+id);
  }



  updateTransaction(Transaction:ITransaction)
  {
    return this.http.put<any>(`${environment.url}/transaction/`+Transaction.id,Transaction);
  }

  deleteTransaction(idA:number)
  {
    return this.http.delete(`${environment.url}/transaction/`+idA);
  }

  // ----------------------------------------- historique des transactionsdu client connecter

  getHistoriqueTransaction():Observable<Transaction>{

    return this.http.get(`${environment.url}/transaction/connected`);

  }

}
